import React, { createContext, useState, useMemo, useCallback } from 'react'
import GlassVUService from '../../services/GlassVU/GlassVU.service'
import PropTypes from 'prop-types'
import { trackEvent } from '../../utils/functions'

export const GlassVUContext = createContext()

export const GlassVUContextProvider = (props) => {
  const [allDevices, setallDevices] = useState([])

  const fetchDevices = useCallback((portalName) => {
    GlassVUService.fetchDevices(portalName).then((res) => {
      setallDevices(res.data)
    })
  }, [])

  const addDevice = useCallback(async (portalName, glassName, users, licenceId) => {
    trackEvent('Added Device')
    return await GlassVUService.addDevice(
      glassName,
      portalName,
      users,
      licenceId
    )
  }, [])

  const getDevice = useCallback(async (selectedDeviceId) => {
    trackEvent('Get Device')
    return await GlassVUService.getDevice(selectedDeviceId)
  }, [])

  const editDevice = useCallback(async (
    selectedDeviceId,
    glassName,
    users,
    portalName,
    licenceId
  ) => {
    trackEvent('Edited Device')
    return await GlassVUService.editDevice(
      selectedDeviceId,
      glassName,
      users,
      portalName,
      licenceId
    )
  }, [])

  const removeDevice = useCallback(async (token) => {
    trackEvent('Device Removed')
    return await GlassVUService.removeDevice(token)
  }, [])

  const releaseDevice = useCallback(async (token) => {
    trackEvent('Device Released')
    return await GlassVUService.releaseDevice(token)
  }, [])

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      fetchDevices,
      allDevices,
      addDevice,
      editDevice,
      removeDevice,
      releaseDevice,
      getDevice
    }),
    [fetchDevices, allDevices, addDevice, editDevice, removeDevice, releaseDevice, getDevice]
  )

  return (
    <GlassVUContext.Provider value={contextValue}>
      {props.children}
    </GlassVUContext.Provider>
  )
}

GlassVUContextProvider.propTypes = {
  children: PropTypes.object
}
